import React, { useEffect, useMemo, useRef, useState } from 'react';

/**
 * Buscador de cliente con sugerencias (mismo patrón que venta completa).
 */
export default function ClienteSearchField({
  value,
  onChange,
  onSelect,
  clientes = [],
  inputClass,
  boxClass = '',
  divideClass = '',
  textPri = '',
  textMuted = '',
  label = 'Nombre / Razón social',
  required = false,
  placeholder = 'Buscar o escribir cliente…',
  hint = null,
  labelClass = '',
  id = 'cliente-search',
}) {
  const searchRef = useRef(null);
  const [open, setOpen] = useState(false);

  const filtered = useMemo(() => {
    const term = String(value || '').trim().toLowerCase();
    if (!term) return clientes.slice(0, 8);
    return clientes
      .filter((c) =>
        (c.razonSocial || c.name || '').toLowerCase().includes(term)
        || (c.email || '').toLowerCase().includes(term))
      .slice(0, 8);
  }, [clientes, value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (next) => {
    onChange(next);
    setOpen(true);
  };

  const pick = (cliente) => {
    const name = cliente.razonSocial || cliente.name || '';
    onChange(name);
    if (typeof onSelect === 'function') onSelect(cliente);
    setOpen(false);
  };

  return (
    <div>
      {label && (
        <label htmlFor={id} className={`block text-xs font-medium mb-1.5 ${labelClass}`}>
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
      <div className="relative" ref={searchRef}>
        <input
          id={id}
          type="text"
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          onFocus={() => setOpen(true)}
          placeholder={placeholder}
          required={required}
          className={inputClass}
          autoComplete="off"
        />
        {open && filtered.length > 0 && (
          <div className={`absolute z-30 left-0 right-0 mt-1 border rounded-xl shadow-lg max-h-52 overflow-y-auto ${boxClass}`}>
            {filtered.map((cliente) => {
              const key = cliente._id || cliente.id || cliente.razonSocial;
              const title = cliente.razonSocial || cliente.name || 'Sin nombre';
              return (
                <button
                  key={key}
                  type="button"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => pick(cliente)}
                  className={`w-full text-left px-4 py-2.5 border-b last:border-b-0 transition-colors ${divideClass} hover:bg-[#1F80FF]/10`}
                >
                  <div className={`font-medium text-sm ${textPri}`}>{title}</div>
                  <div className={`text-xs ${textMuted}`}>
                    {[cliente.email, cliente.pais].filter(Boolean).join(' · ')}
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
      {hint && <p className={`mt-1 text-[11px] ${textMuted}`}>{hint}</p>}
    </div>
  );
}
